
<div id="carouselExampleCaptions" class="carousel slide mt-0 pt-0 mb-4" data-bs-ride="carousel">
  <div class="carousel-indicators">
    <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="0" class="active"
      aria-current="true" aria-label="Slide 1"></button>
    <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="1" aria-label="Slide 2"></button>
    <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="2" aria-label="Slide 3"></button>
  </div>
  <div class="carousel-inner">
    <div class="carousel-item active">
      <img src="apple.svg" class="d-block w-100" alt="..." />

      <div class="banner-overlay" style="max-width: 600px;">
        <span class="badge featured-badge rounded-pill mb-2">Featured Harvest</span>
        <h5 class="heading" style="margin-bottom: 15px;">
          <span style="font-weight: 800; color: white; display: block;">Premium</span>
          <span style="font-weight: 800; color: #BFD7FF; display: block;">Gala Apples</span>
        </h5>
        <p
          style="font-size: 14px; font-weight: 500; font-family: 'Inter', sans-serif; color: #e2e8f0; margin-bottom: 20px; line-height: 1.5; max-width: 80%;">
          Direct from growers in Central Valley. Early access available for premium buyers with guaranteed logistics.
        </p>
        <div class="d-flex gap-3">
          <button class="view-quotes fw-semibold" (click)="viewQuotes('7ddfa237-1c42-429d-a2a3-ddb7d4de35ec')">View Quotes
            &rarr;</button>
           <button class="market-report" (click)=navigateToTradeGPT()>Market
            Report</button>
        </div>
      </div>
    </div>
    <div class="carousel-item">
      <img src="avocado.svg" class="d-block w-100" alt="..." />

      <div class="banner-overlay" style="max-width: 600px;">
        <span class="badge featured-badge rounded-pill mb-2">Featured Harvest</span>
        <h5 class="heading" style="margin-bottom: 15px;">
          <span style="font-weight: 800; color: white; display: block;">Premium</span>
          <span style="font-weight: 800; color: #BFD7FF; display: block;">Hass Avocado</span>
        </h5>
        <p
          style="font-size: 14px; font-weight: 500; font-family: 'Inter', sans-serif; color: #e2e8f0; margin-bottom: 20px; line-height: 1.5; max-width: 80%;">
          Direct from growers in Central Valley. Early access available for premium buyers with guaranteed logistics.
        </p>
       <div class="d-flex gap-3">
          <button class="view-quotes fw-semibold" (click)="viewQuotes('dd2d21e5-d9c5-43bd-b972-e72d7139376d')">View Quotes
            &rarr;</button>
           <button class="market-report" (click)=navigateToTradeGPT()>Market
            Report</button>
        </div>
      </div>
    </div>
    <div class="carousel-item">
      <img src="mandarins.svg" class="d-block w-100" alt="..." />

      <div class="banner-overlay" style="max-width: 600px;">
        <span class="badge featured-badge rounded-pill mb-2">Featured Harvest</span>
        <h5 class="heading" style="margin-bottom: 15px;">
          <span style="font-weight: 800; color: white; display: block;">Premium</span>
          <span style="font-weight: 800; color: #BFD7FF; display: block;">Wogan Mandarin</span>
        </h5>
        <p
          style="font-size: 14px; font-weight: 500; font-family: 'Inter', sans-serif; color: #e2e8f0; margin-bottom: 20px; line-height: 1.5; max-width: 80%;">
          Direct from growers in Central Valley. Early access available for premium buyers with guaranteed logistics.
        </p>
        <div class="d-flex gap-3">
          <div class="d-flex gap-3">
          <button class="view-quotes fw-semibold" (click)="viewQuotes('944bf91f-96e2-4de8-82db-9f79c7cf35ec')">View Quotes
            &rarr;</button>
           <button class="market-report" (click)=navigateToTradeGPT()>Market
            Report</button>
        </div>
        </div>
      </div>
    </div>
  </div>
  <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="prev">
    <span class="carousel-control-prev-icon visually-hidden" aria-hidden="true"></span>
    <span class="visually-hidden">Previous</span>
  </button>
  <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="next">
    <span class="carousel-control-next-icon visually-hidden" aria-hidden="true"></span>
    <span class="visually-hidden">Next</span>
  </button>
</div>
